import React from 'react';
import { Redirect } from 'react-router-dom'
import '../../../styles/requestConfirmed.css';
import agent from '../../../api/agent';
import {inject, observer} from "mobx-react";

@inject('authStore', 'userStore', 'navigatorStore')
// @withRouter
@observer
export default class RequestConfirmed extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            browseOtherArtworks: false
        }
    }

    componentDidMount() {
        agent.Auth.verifyEmail(this.props.match.params.key)
            .then((res) => {
                // console.log(res);
                if(res.error=="False")
                this.setState({
                    success : true
                })
                if(res.error=="True")
                this.setState({
                    failure : true
                })
            })
    }
    handleBrowseOtherArtworksClick() {
        this.setState({
            browseOtherArtworks: true
        })
    }
    resendVerificationEmail() {
        agent.Auth.sendEmailVerification(localStorage.getItem("profile_id"))
            .then((res) => {
                // console.log(res);
                this.props.navigatorStore.openErrorModal(res.message, false,null, true)
            })
    }
    render() {
        if (this.state.browseOtherArtworks) {
            return (
                <Redirect push to="/" />
            )
        }
        if (this.state.success)
            return (
                <div className="col-sm-12 background-grey">
                    <article className="post-88 page type-page status-publish hentry">
                        <div className="woocommerce">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <div className="heading-welcome_">
                                        Email Verified
                                    <hr className="line-category-name margin-auto"></hr>
                                    </div>
                                </div>
                                <div className="col-sm-6 UploadPaintingCard text-center no-margin">
                                    <img className="success-gold" src={require("../../../assets/success_gold_png.png")} />

                                    <p className="success-text">Thank you, your email has been verified</p>

                                    <button className="btn-black height-48" onClick={this.handleBrowseOtherArtworksClick.bind(this)}>
                                        HOME
                                </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>

            )


        if (this.state.failure) {
            return (

                <div className="col-sm-12 background-grey">
                    <article className="post-88 page type-page status-publish hentry">
                        <div className="woocommerce">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <div className="heading-welcome_">
                                        NOT VERIFIED
                                            <hr className="line-category-name margin-auto"></hr>
                                    </div>
                                </div>
                                <div className="col-sm-6 UploadPaintingCard text-center ">
                                    {/* <img className="success-gold" src={require("../../../assets/Success_black_png.png")} /> */}
                                    {/* <div className="error-border"> */}
                                    {/* <div className="path-vert">
                                        <div className="path-hr">
                                        </div>
                                    </div> */}
                                {/* </div> */}
                                    <p className="success-text">
                                       Sorry, the email could not be verified.
                                        </p>

                                    {/* <button className="masterpieces-primary-buttons btn-primary height-48 p-35 mb-25" onClick={this.resendVerificationEmail.bind(this)}>
                                        Resend Verification Email
                                        </button> */}

                                </div>

                            </div>

                        </div>
                    </article>
                </div>

            )
        }
        return <div></div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/onboarding/emailVerified.js